import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const FeaturedOffers150X150RootActionPath = 'core/FeaturedOffers150X150/GET';

export const FEATURED_OFFERS_150X150_GET_SUCCESS = `${FeaturedOffers150X150RootActionPath}_${SUCCESS_SUFFIX}`;
export const FEATURED_OFFERS_150X150_GET_FAILURE = `${FeaturedOffers150X150RootActionPath}_${FAILURE_SUFFIX}`;
